import { useCallback } from "react";

import { getUser, useReferralCustomer } from "@jti/rest-api";
import { useDispatch } from "@jti/store/reduxHooks";
import { setLoyaltyReminder } from "@jti/store/slices/loyaltyCoreSlice";

export const useLoyaltyCustomerState = () => {
  const dispatch = useDispatch();
  const { uuid = "", ciam_token = "" } = getUser();

  const syncLoyaltyCustomerState = useCallback(
    (data: { has_first_purchase?: boolean | null; parent_code?: string }) => {
      dispatch(
        setLoyaltyReminder({
          hasFirstPurchase: Boolean(data.has_first_purchase),
          parentCodeExists: Boolean(data.parent_code),
        })
      );
    },
    [dispatch]
  );

  const referralCustomerQuery = useReferralCustomer(
    { uuid, ciam_token },
    {
      onSuccess: syncLoyaltyCustomerState,
    }
  );

  return referralCustomerQuery;
};
